import { render, staticRenderFns } from "./LoyaltyBlock.vue?vue&type=template&id=57ad05c8&scoped=true&"
import script from "./LoyaltyBlock.vue?vue&type=script&lang=js&"
export * from "./LoyaltyBlock.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyBlock.vue?vue&type=style&index=0&id=57ad05c8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad05c8",
  null
  
)

export default component.exports